import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWrapper } from './Styled';

class Button extends React.Component {
  render() {
    const { children } = this.props;
    return (
      <ButtonWrapper {...this.props}>
        {children}
      </ButtonWrapper>
    );
  }
}

Button.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Button;
